<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container-fluid">
      <div class="card mt-3 text-white bg-dark">
        <div class="topnav bg-dark">
          <a class="active" href="#" v-on:click="navToogle('paymentPage')">Payment</a>
          <a href="#" v-on:click="navToogle('deletedData')">Deleted</a>
        </div>
        <div v-if="paymentPage" class="mt-3">
          <span class="m-3">Payment List</span>
          <div class="card-body">
            <div class="table-responsive">
              <table class="custom_table" style="color: white">
                <thead>
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">SP Order Id</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">SP Message</th>
                    <th scope="col">Transaction Status</th>
                    <th scope="col">Payment Status</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in paymentData" :key="data.id">
                    <td>{{ data.id }}</td>
                    <td>{{ data.sp_order_id }}</td>
                    <td>{{ data.amount }} taka</td>
                    <td>{{ data.customer_name }}</td>
                    <td>{{ data.sp_massage }}</td>
                    <td>{{ data.transaction_status }}</td>
                    <td>
                      <h6>
                        <div v-if="data.sp_massage=='Success'">
                          <span
                            v-if="data.transaction_status==null"
                            class="badge bg-primary"
                            style="cursor: pointer"
                            v-on:click="transactionStatusVerify(data.sp_order_id)"
                          >Verify</span>&ensp;
                          <span v-else class="badge bg-success" disabled>Verified</span>&ensp;
                        </div>
                      </h6>
                    </td>
                    <td>
                      <h6>
                        <span
                          class="badge bg-info"
                          style="cursor: pointer"
                          v-on:click="viewPage(data.sp_order_id)"
                        >
                          <i class="fas fa-eye-slash"></i>
                        </span>&ensp;
                        <span
                          class="badge bg-danger"
                          style="cursor: pointer"
                          v-on:click="deletePayment(data.sp_order_id)"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </span>&ensp;
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else class="mt-3">
          <span class="m-3">Deleted Data</span>
          <div class="card-body">
            <div class="table-responsive">
              <table class="custom_table" style="color: white">
                <thead>
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">SP Order Id</th>
                    <!-- <th scope="col">Customer Order Id</th>
                    <th scope="col">Invoice No</th>-->
                    <th scope="col">Amount</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Customer Name</th>
                    <!-- <th scope="col">Customer Address</th> -->
                    <!-- <th scope="col">Customer City</th> -->
                    <th scope="col">SP Message</th>
                    <th scope="col">Transaction Status</th>
                    <!-- <th scope="col">Completed</th>
                    <th scope="col">Deleted</th>
                    <th scope="col">Created at</th>
                    <th scope="col">Updated at</th>
                    <th scope="col">User Id</th>-->
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in delData" :key="data.id">
                    <td>{{ data.id }}</td>
                    <td>{{ data.sp_order_id }}</td>
                    <!-- <td>{{ data.customer_order_id }}</td>
                    <td>{{ data.invoice_no }}</td>-->
                    <td>{{ data.amount }}</td>
                    <td>{{ data.currency }}</td>
                    <td>{{ data.customer_name }}</td>
                    <!-- <td>{{ data.customer_address }}</td> -->
                    <!-- <td>{{ data.customer_city }}</td> -->
                    <td>{{ data.sp_massage }}</td>
                    <td>{{ data.transaction_status }}</td>
                    <!-- <td>{{ data.completed }}</td>
                    <td>{{ data.deleted }}</td>
                    <td>{{ data.created_at }}</td>
                    <td>{{ data.updated_at }}</td>
                    <td>{{ data.user_id }}</td>-->
                    <td>
                      <h6>
                        <span
                          class="badge bg-success"
                          style="cursor: pointer"
                          v-on:click="recoverPayment(data.sp_order_id)"
                        >Recovery</span>&ensp;
                        <span
                          class="badge bg-danger"
                          style="cursor: pointer"
                          v-on:click="permanentDelete(data.sp_order_id)"
                        >Delete</span>&ensp;
                      </h6>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "Payment",
  components: { Loading },
  data() {
    return {
      paymentData: [],
      delData: [],
      paymentPage: true,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars"
    };
  },
  methods: {
    navToogle(status) {
      if (status == "deletedData") {
        this.paymentPage = false;
        console.log(this.paymentPage);
      } else if (status == "paymentPage") {
        this.paymentPage = true;
        console.log(this.paymentPage);
      }
    },
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/payment",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.paymentData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async getallDelete() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/payment/getallDeleted",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.delData = res.data;
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async deletePayment(id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl + this.$api + this.$version1 + "/payment/deleted",
          { orderId: id, deleted: 1 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.getData();
          this.getallDelete();
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async recoverPayment(id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl + this.$api + this.$version1 + "/payment/deleted",
          { orderId: id, deleted: 0 },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.getData();
          this.getallDelete();
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async permanentDelete(id) {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.delete(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/payment/parmanentDelete" +
            "?orderId=" +
            id,

          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200 || res.status == 201) {
          this.getData();
          this.getallDelete();
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async transactionStatusVerify(id) {
      console.log("working");
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/payment/payment-update/" +
            id,
          {
            sp_code: 1000
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json"
            }
          }
        );
        this.isLoading = false;
        if (res.status == 200) {
          this.getData();
          console.log(res);
        } else {
          this.$vToastify.error("Could not fetch data!");
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    viewPage(vp) {
      this.$router.push("/details/" + vp);
    }
  },
  mounted() {
    // use this for get
    this.getData();
    this.getallDelete();
  }
};
</script>
<style scoped>
@import "../../assets/css/audioBook.scss";
</style>
